import type { ReactNode } from 'react';

/**
 * The persistent instruction band over the camera. It stays on screen for the
 * whole live view — a guest who looks away and back must not have to remember
 * what they were told.
 */
export function Prompt({
  children,
  sub,
  kiosk = false,
  pulse = true,
}: {
  children: ReactNode;
  sub?: ReactNode;
  kiosk?: boolean;
  pulse?: boolean;
}) {
  // Top of the live view so it does not fight the brand logo in the lower third.
  return (
    // One padding declaration, not `pt-12 pt-safe`: both set padding-top, and
    // the utility that wins is whichever Tailwind emits last — which was
    // pt-safe's `max(1rem, …)`, so the 3rem was silently dead and the band sat
    // hard against the top edge on anything without a notch.
    <div className="pointer-events-none absolute inset-x-0 top-0 z-40 flex flex-col items-center gap-2 bg-gradient-to-b from-ink/90 via-ink/50 to-transparent px-6 pb-10 pt-[max(3rem,env(safe-area-inset-top))] text-center">
      <p
        className={[
          'font-display uppercase leading-none tracking-tight text-bone',
          kiosk ? 'text-6xl' : 'text-3xl',
          pulse ? 'animate-pulse' : '',
        ].join(' ')}
      >
        {children}
      </p>
      {sub ? (
        <p className={`text-bone/60 ${kiosk ? 'text-2xl' : 'text-sm'}`}>{sub}</p>
      ) : null}
    </div>
  );
}
